import {
  Card,
  CardContent,
  CardHeader,
  CardTitle
} from "../../../components/tailwindComponent/ui/card";
import { getCategoryStyles } from "../../../utils/utils";
import { BestPracticeCard } from "./BestPracticeCard";

interface CategoryProps {
  category: any;
  detailedSimulations: any;
}

export function BestPracticeCategory({ category, detailedSimulations }: CategoryProps) {
  const styles = getCategoryStyles(category.color);
  const CategoryIcon = category.icon;

  const wasteSimulations = detailedSimulations?.results?.waste || [];
  const actionData = detailedSimulations?.results?.actions || [];

  const filterByProcessIds = (data: any, targetIdString: any) => {
    const targetIds = targetIdString.split(",").map((id: any) => id.trim());
    return data.filter((item: any) => {
      const ids = item.wasteId.split(",").map((id: any) => id.trim());
      return ids.some((id: any) => targetIds.includes(id));
    });
  };

  if (!wasteSimulations || wasteSimulations.length === 0) {
    return (
      <Card>
        <div className="flex flex-col items-center justify-center py-10 text-muted-foreground">
          <CardTitle className="text-xl">No data available</CardTitle>
        </div>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-3">
          <div className={`p-2 rounded-lg ${styles.background}`}>
            <CategoryIcon className={`h-5 w-5 ${styles.icon}`} />
          </div>
          <div>
            <CardTitle className="text-xl mb-0">{category.title}</CardTitle>
            <p className="text-sm text-muted-foreground">
              {detailedSimulations.length} practice
              {detailedSimulations.length !== 1 ? "s" : ""} available
            </p>
          </div>
        </div>
      </CardHeader>

      <CardContent>
        <div className="grid gap-4 grid-cols-2 md:grid-cols-3">
          {wasteSimulations.map((practice: any) => {
            const actionDetails = filterByProcessIds(actionData, practice.wasteId);
            return (
              <BestPracticeCard
                key={practice.id}
                practice={practice}
                categoryColor={category.color}
                categoryIcon={category.icon}
                actionDetails={actionDetails}
              />
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
